import React from 'react'
import MovieAttributesAccess from './MovieAttributesAccess'
import MovieDescriptionAccess from './MovieDescriptionAccess'
import MovieFskAccess from './MovieFskAccess'
import MovieLengthAccess from './MovieLengthAccess'
import MovieGenresAccess from './MovieGenresAccess'
import MoviePersonsAccess from './MoviePersonsAccess'

const MovieInformationAccess = ({
    item,
    filterType,
    filterValue,
    queryStringValues,
    translation //ToDo

}) => {
    const { 
        description, 
        descriptionShort, 
        actors, directors, 
        length, 
        fsk, 
        technologyAttributes, 
        genres, 
        performances 
    } = item


    return (
        <div className='access-movie-information'>
            <dl className="access-dl text-medium access-typo">
                <MovieDescriptionAccess
                    description={description}
                    descriptionShort={descriptionShort}
                />

                <MovieAttributesAccess
                    technologyAttributes={technologyAttributes}
                    filterType={filterType}
                    filterValue={filterValue}
                    queryStringValues={queryStringValues}
                    performances={performances}
                    translation={translation}
                />

                <MovieFskAccess
                    fsk={fsk}
                />

                <MovieLengthAccess
                    length={length}
                />

                <MovieGenresAccess
                    genres={genres}
                />

                <MoviePersonsAccess
                    transId='directors'
                    persons={directors}
                />

                <MoviePersonsAccess
                    transId='actors'
                    persons={actors}
                />
            </dl>
        </div>
    )
}

export default MovieInformationAccess